var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-list-item',{attrs:{"to":"/manager/salesOverview"}},[_c('v-list-item-icon',[_c('v-icon',[_vm._v("mdi-cart-percent")])],1),_c('v-list-item-title',[_vm._v("Sales Overview")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }